import React, { Component } from 'react';
import Media from 'react-media';
import memoize from 'fast-memoize';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DatetimeTableCell from '../DatetimeTableCell/DatetimeTableCell';
import Message from '../Message/Message';
import Table from '../Table/Table';
import Th from '../Th/Th';
import './TradesTable.css';

export default class TradesTable extends Component {
  constructor(props) {
    super(props);
    this.defaultSortBy = ['start_time', 'placed_at', 'home_team', 'away_team', 'sport', 'order_id', 'sport_event_id'];
    this.state = {
      trades: null,
      sortBy: this.defaultSortBy[0],
      sortAsc: true,
    };
    this.sort = memoize(Table.sort);
  }

  componentWillReceiveProps(nextProps) {
    const { sortBy, sortAsc } = this.state;
    const trades = this.sort(nextProps.data, [sortBy, ...this.defaultSortBy], sortAsc);
    this.setState({ trades });
  }

  sortBy(prop) {
    const { trades, sortBy, sortAsc } = this.state;

    if (prop === sortBy) {
      // Already sorted by this property - reverse order only
      this.setState({ sortAsc: !sortAsc, trades: trades.reverse() });
    } else {
      const sorted = this.sort(trades, [prop, ...this.defaultSortBy], true);
      this.setState({ sortBy: prop, sortAsc: true, trades: sorted });
    }
  }

  static renderBetType(val) {
    if (typeof val !== 'string') return <div />;

    const disallowedTags = ['for', 'tset', 'all', 'vset1', 'tp'];
    const tags = val.split(',').filter(t => !disallowedTags.includes(t));

    const lastTag = tags.length - 1
    tags[lastTag] = val.includes('ah') ? (+tags[lastTag] / 4) : tags[lastTag];
    if (tags.includes('ah')){
      tags[lastTag] = tags.includes('a') ? (+tags[lastTag] * -1) : tags[lastTag];
      tags[lastTag] = +tags[lastTag] >= 0 ? `+${tags[lastTag]}` : tags[lastTag];
    }

    return (
      <ul className="list-inline">
        {tags.map(type =>
          <li key={type} className={`TradesTable__bet-type TradesTable__bet-type--${type}`}>{type}</li>)}
      </ul>
    );
  }

  static renderPrice(value, isColoured) {
    let className = null;
    if (isColoured) {
      if (value > 0) className = 'text-success';
      else if (value < 0) className = 'text-danger';
      else className = 'text-pale';
    }

    return (
      <span className={className}>
        ${value.toFixed(1)}
      </span>
    );
  }

  render() {
    const { sortBy, sortAsc, trades } = this.state;
    const { profitLoss } = this.props;
    if (!Array.isArray(trades) || trades.length < 1) return <Message type="warning" text="No trades to display" />;

    const headings = {
      start_time: <FontAwesomeIcon icon="clock" />,
      home_team: <span>Home<br />team</span>,
      away_team: <span>Away<br />team</span>,
      trigger: 'Trigger',
      bet_type: <span>Bet<br />type</span>,
      placed_at: <span>Placed<br />at</span>,
      bookmaker: <Media query={{ maxWidth: 1250 }}>{matches => (matches ? <span>Bookie</span> : <span>Bookmaker</span>)}</Media>,
      strategy: 'Strategy',
      price: 'Price',
      [profitLoss ? 'profit_loss' : 'stake']: profitLoss ? 'P/L' : 'Stake',
      order_id: <span>Order<br />ID</span>,
      sport_event_id: <span>Event<br />ID</span>,
    };

    return (
      <Table className="TradesTable table-nowrap-header">
        <thead>
          <tr>
            {Object.keys(headings).map(col => (
              <Th
                key={col}
                prop={col}
                sortBy={sortBy}
                sortAsc={sortAsc}
                onSort={() => this.sortBy(col)}
              >
                {headings[col]}
              </Th>
            ))}
          </tr>
        </thead>
        <tbody>
          {
            trades.map((b, i) => (
              <tr key={i}>
                <DatetimeTableCell date={b.start_time} displayFormat="HH:mm" />
                <td>{b.home_team}</td>
                <td>{b.away_team}</td>
                <td>{b.trigger}</td>
                <td>{TradesTable.renderBetType(b.bet_type)}</td>
                <DatetimeTableCell date={b.placed_at} displayFormat="HH:mm:ss" />
                <td>{b.bookmaker}</td>
                <td>{b.strategy}</td>
                <td>{b.price.toFixed(3)}</td>
                <td>{TradesTable.renderPrice(profitLoss ? b.profit_loss : b.stake, profitLoss)}</td>
                <td>{b.order_id}</td>
                <td>{b.sport_event_id}</td>
              </tr>
            ))
          }
        </tbody>
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TradesTable/TradesTable.js